// [BB-EXP] - AT1 auto: Chip to identify AT1 auto experiment dossiers

import { Chip } from '@evaneos/b2b-ui';
import ScienceIcon from '@evaneos/b2b-ui/icons/Science';

type Props = {
    size?: 'small' | 'medium';
    className?: string;
};

/**
 * [BB-EXP] - AT1 auto
 * Green Erlenmeyer chip to identify dossiers in AT1 auto experiment
 *
 * Displayed on all views when dossier has isAt1Auto flag set to true
 */
export const AT1AutoExperimentChip = ({ size = 'small', className }: Props) => {
    return (
        <Chip
            icon={<ScienceIcon />}
            label=""
            size={size}
            variant="outlined"
            className={className}
            sx={{
                minWidth: 'auto',
                height: 24,
                width: size === 'small' ? 24 : 32,
                borderRadius: 16,
                backgroundColor: '#00E676',
                border: '1px solid #00C853',
                boxShadow: '0 0 8px rgba(0, 230, 118, 0.4)',
                '& .MuiChip-label': {
                    display: 'none',
                },
                '& .MuiChip-icon': {
                    margin: 0,
                    fontSize: size === 'small' ? 16 : 20,
                    color: '#000000',
                },
                '&:hover': {
                    backgroundColor: '#00E676',
                    boxShadow: '0 0 12px rgba(0, 230, 118, 0.6)',
                },
            }}
        />
    );
};
